import { DisabledTooltip } from 'modules/experiments/components/pages/CommonStyled';
import {
  useChooseCampaignTakeover,
  useExperimentsTranslations,
  useExperimentsUserPermission,
} from 'modules/experiments/hooks';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { ExperimentFlask } from 'ui/icons';
import { PageHeader } from 'ui/pageHeader';

export const ExperimentsIndexHeader = () => {
  const { t } = useExperimentsTranslations();
  const { viewOnlyPermission } = useExperimentsUserPermission();
  const { openChooseCampaignTakeover } = useChooseCampaignTakeover();

  let newExperimentButton = <></>;
  switch (true) {
    case viewOnlyPermission:
      newExperimentButton = (
        <DisabledTooltip tooltipContent={t('permissions.createNew')}>
          <PrimaryButton
            data-test="experiments-index-create-button"
            size={BUTTON_SIZES.LARGE}
            isDisabled={true}
          >
            <ExperimentFlask />
            {t('button.createNew')}
          </PrimaryButton>
        </DisabledTooltip>
      );
      break;
    default:
      newExperimentButton = (
        <PrimaryButton
          data-test="experiments-index-create-button-choose-campaign"
          size={BUTTON_SIZES.LARGE}
          onClick={openChooseCampaignTakeover}
        >
          <ExperimentFlask />
          {t('button.createNew')}
        </PrimaryButton>
      );
      break;
  }

  return (
    <PageHeader data-test="experiments-index-page-header" pageActions={newExperimentButton}>
      {t('title.index')}
    </PageHeader>
  );
};
